import { lazy, Suspense } from "react";
import { CodeBlock } from "@/components/storyboard/code/CodeBlock";
import type { CodeEditorProps } from "@/components/storyboard/code/CodeEditor";

const CodeEditor = lazy(
  () => import("@/components/storyboard/code/CodeEditor")
);

/**
 * Lazily-loaded `CodeEditor`. Keeps CodeMirror out of the main bundle: until
 * the editor chunk has loaded it renders the read-only `CodeBlock` (same code,
 * same theme) as the Suspense fallback, so the transition is seamless.
 */
export const LazyCodeEditor = (props: CodeEditorProps) => (
  <Suspense
    fallback={
      <div className={props.fill ? "h-full overflow-auto" : undefined}>
        <CodeBlock code={props.value} defaultLanguage={props.language} />
      </div>
    }
  >
    <CodeEditor {...props} />
  </Suspense>
);
